export default __webpack_public_path__ + "static/about-us-hero--mobile-8824e7e562768b10ba656084f9b5aae2.jpg";